/* Config */
import appConfig from '../../appConfig'

const MOBILE_COMPONENTS = {
  TABBAR: 'tabbar',
  M_HEADER: 'm/header',
  M_HEROUSEL: 'm/herousel',
  M_MARKETINGBILLBOARD: 'm/marketingbillboard',
  M_DEALOFTHEDAY: 'm/dealoftheday',
  FAVORITE: 'favoriteshandler',
  ADD_TO_CART: 'addtocart',
  DELIVERY: 'delivery',
  FOOTER: 'footer',
  ADD_TO_MY_LIST: 'AddToMyLists',
  USER_CONTENT: 'Yorumlar',
  BEST_REVIEW: 'bestReview',
  DELIVERY_OPTIONS: 'DeliveryOptions',
  PRODUCT_DESCRIPTION: 'ProductDescription',
  ASK_TO_SELLER: 'AskToSeller',
  QUESTION_AND_ANSWER: 'QuestionAndAnswer',
  RECOMMENDATION: 'Recommendation',
  INSTALLMENT: 'Installment',
  LOAN: 'Loan',
  BUYBACK: 'Buyback',
  WINNER_CAMPAIGN: 'WinnerCampaign',
  CAMPAIGN_SECTION: 'CampaignSection',
  SPONSORED_PRODUCTS: 'SponsoredProducts',
  CAMPAIGN_BUNDLE: 'CampaignBundle',
  MERCHANT_COUPONS: 'MerchantCoupons',
  VAS: 'Vas',
  SPONSORED_BRAND_COMPONENT: 'SponsoredBrandComponent',
  PREMIUM_BANNER: 'PremiumBanner',
  MORIA_LISTING: 'MoriaListing',
  BUYBACK_ROW: 'BuybackRow',
  BRAND_CONTENT: 'BrandRowMobile',
  FOLLOW_AND_COLLECT: 'Follow',
  SHIPPING_LOCATION: 'ShippingLocation',
  BNPL: 'Bnpl',
  ADVERTISEMENT: 'advertisement',
  PREMIUM_CONTENT: 'premiumContent',
  PRODUCT_SAFETY_INFORMATION: 'ProductSafetyInformation',
}

const DEVICE_TYPE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
}

const MOBILE_COMPONENTS_OPTIONS = {
  [MOBILE_COMPONENTS.TABBAR]: {
    id: 5,
    componentId: 5,
    isFullWidth: true,
    componentTypeName: 'Tabbar',
    margin: 0,
    url: 'tabbar',
    clientUrl: 'tabbar',
    cacheStatus: true, // it depends by personalize herousel
    cacheKey: 'tabbar',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: true,
  },
  [MOBILE_COMPONENTS.M_HEADER]: {
    id: 26,
    componentId: 26,
    isFullWidth: true,
    componentTypeName: 'm/header',
    margin: 0,
    url: 'm/header',
    clientUrl: 'm/header',
    cacheStatus: false,
    cacheKey: 'm/header',
    paramater: {
      asyncFragmentsCss: true,
    },
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: true,
  },
  [MOBILE_COMPONENTS.FOOTER]: {
    id: 29,
    componentId: 29,
    isFullWidth: true,
    componentTypeName: 'footer',
    margin: 0,
    url: 'footer',
    clientUrl: 'footer',
    cacheStatus: true,
    cacheKey: 'voltran-footer',
    paramater: {
      mobile: true,
    },
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.FAVORITE]: {
    id: 28,
    componentId: 28,
    isFullWidth: false,
    componentTypeName: 'favoriteshandler',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/favoriteshandler`,
    clientUrl: `${appConfig.cacVoltranUrl}/favoriteshandler`,
    cacheStatus: true,
    cacheKey: 'favoriteshandler',
    cacheExpireTime: 1000 * 60 * 60,
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.ADD_TO_CART]: {
    id: 32,
    componentId: 43,
    isFullWidth: false,
    componentTypeName: 'addtocart',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.checkoutUi.serverUrl}/addtocart`,
      clientUrl: `${appConfig.checkoutUi.clientUrl}/addtocart`,
    },
    cacheStatus: true,
    cacheKey: 'addtocart',
    cacheExpireTime: 1000 * 60 * 60,
    timeout: 300,
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.DELIVERY]: {
    id: 98,
    componentId: 99,
    isFullWidth: false,
    componentTypeName: 'delivery',
    margin: 0,
    url: 'delivery',
    clientUrl: 'delivery',
    cacheStatus: false,
    cacheKey: 'delivery',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.ADD_TO_MY_LIST]: {
    id: 37,
    componentId: 37,
    isFullWidth: false,
    componentTypeName: 'AddToMyLists',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/AddToMyLists`,
    clientUrl: `${appConfig.cacVoltranUrl}/AddToMyLists`,
    cacheStatus: true,
    cacheKey: 'AddToMyLists',
    dataTestId: 'AddToMyLists',
    paramater: {
      mobileView: true
    },
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.USER_CONTENT]: {
    id: 38,
    componentId: 38,
    isFullWidth: false,
    componentTypeName: 'userContentComments',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/Yorumlar`,
      clientUrl: `${appConfig.userContent.clientUrl}/Yorumlar`,
    },
    cacheStatus: false,
    cacheKey: 'Yorumlar',
    paramater: {
      mobileView: true,
      pageSize: 5,
      appType: 'Mobile Site'
    },
    isMandatory: false,
    timeout: 300,
    clientTimeout: 1000,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.BEST_REVIEW]: {
    id: 39,
    componentId: 39,
    isFullWidth: true,
    componentTypeName: 'bestReview',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/bestReview`,
      clientUrl: `${appConfig.userContent.clientUrl}/bestReview`,
    },
    cacheStatus: false,
    cacheKey: 'bestReview',
    dataTestId: 'bestReview',
    timeout: 300,
    paramater: {},
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.DELIVERY_OPTIONS]: {
    id: 40,
    componentId: 40,
    isFullWidth: false,
    componentTypeName: 'DeliveryOptions',
    margin: 0,
    url: 'DeliveryOptions',
    clientUrl: 'DeliveryOptions',
    cacheStatus: true,
    cacheExpireTime: 1000 * 60 * 60 * 24,
    cacheKey: 'DeliveryOptions',
    dataTestId: 'DeliveryOptionsVoltran',
    isMandatory: false,
    paramater: {
      mobile: true
    },
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.PRODUCT_DESCRIPTION]: {
    id: 41,
    componentId: 41,
    isFullWidth: false,
    componentTypeName: 'ProductDescription',
    margin: 0,
    url: 'ProductDescription',
    clientUrl: 'ProductDescription',
    cacheStatus: false,
    cacheKey: 'ProductDescription',
    dataTestId: 'ProductDescription',
    isMandatory: false,
    paramater: {},
    timeout: 300,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.ASK_TO_SELLER]: {
    id: 42,
    componentId: 42,
    isFullWidth: true,
    componentTypeName: 'AskToSeller',
    margin: 0,
    url: `${appConfig.askToSellerVoltranUrl}/asktoseller/wc`,
    clientUrl: `${appConfig.askToSellerVoltranUrl}/asktoseller/wc`,
    cacheStatus: true,
    cacheKey: 'AskToSeller',
    dataTestId: 'AskToSellerVoltran',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.QUESTION_AND_ANSWER]: {
    id: 43,
    componentId: 43,
    isFullWidth: true,
    componentTypeName: 'QuestionAndAnswer',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/bestQna`,
      clientUrl: `${appConfig.userContent.clientUrl}/bestQna`,
    },
    paramater: {
    },
    cacheStatus: false,
    cacheKey: 'QuestionAndAnswer',
    dataTestId: 'QuestionAndAnswerVoltran',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.RECOMMENDATION]: {
    isFullWidth: true,
    componentTypeName: 'Recommendation',
    margin: 0,
    url: 'recommendation',
    clientUrl: 'recommendation',
    cacheStatus: true,
    cacheKey: 'Recommendation',
    dataTestId: 'RecommendationVoltran',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.INSTALLMENT]: {
    id: 44,
    componentId: 44,
    isFullWidth: true,
    componentTypeName: 'installment',
    margin: 0,
    url: `${appConfig.sardesInstallmentVoltranUrl}/Installment`,
    clientUrl: `${appConfig.sardesInstallmentVoltranUrl}/Installment`,
    cacheStatus: true,
    cacheKey: 'installment',
    dataTestId: 'installment',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.LOAN]: {
    id: 45,
    componentId: 45,
    isFullWidth: true,
    componentTypeName: 'loan',
    margin: 0,
    url: `${appConfig.sardesInstallmentVoltranUrl}/loan`,
    clientUrl: `${appConfig.sardesInstallmentVoltranUrl}/loan`,
    cacheStatus: false,
    cacheKey: 'loan',
    dataTestId: 'loan',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.BUYBACK]: {
    id: 46,
    componentId: 46,
    isFullWidth: true,
    componentTypeName: 'buyback',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/TBA?isOpenTbaDirectly=true`,
    clientUrl: `${appConfig.cacVoltranUrl}/TBA?isOpenTbaDirectly=true`,
    cacheStatus: false,
    cacheKey: 'buyback',
    dataTestId: 'buyback',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.WINNER_CAMPAIGN]: {
    id: 47,
    componentId: 47,
    isFullWidth: true,
    componentTypeName: 'winnerCampaign',
    margin: 0,
    url: `${appConfig.campaignVoltranUrl}/WinnerCampaign`,
    clientUrl: `${appConfig.campaignVoltranUrl}/WinnerCampaign`,
    cacheStatus: true,
    cacheKey: 'winnerCampaign',
    dataTestId: 'winnerCampaign',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.CAMPAIGN_SECTION]: {
    id: 48,
    componentId: 48,
    isFullWidth: true,
    componentTypeName: 'CampaignSection',
    margin: 0,
    url: `${appConfig.campaignVoltranUrl}/CampaignSection`,
    clientUrl: `${appConfig.campaignVoltranUrl}/CampaignSection`,
    paramater: {
      renderType: 'full'
    },
    cacheStatus: true,
    cacheKey: 'CampaignSection',
    dataTestId: 'CampaignSection',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.SPONSORED_PRODUCTS]: {
    id: 49,
    componentId: 49,
    isFullWidth: true,
    componentTypeName: 'sponsoredProducts',
    margin: 0,
    url: `${appConfig.hepsiAdsVoltranUrl}/sponProduct`,
    clientUrl: `${appConfig.hepsiAdsVoltranUrl}/sponProduct`,
    cacheStatus: false,
    paramater: {
      scrollableLayout: true,
      platform: 'mobile',
      mobileSlidesToShow: 2.3,
      devicetype: 'mobile'
    },
    cacheKey: 'sponsoredProducts',
    dataTestId: 'sponsoredProducts',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.CAMPAIGN_BUNDLE]: {
    id: 50,
    componentId: 50,
    isFullWidth: true,
    componentTypeName: 'CampaignBundle',
    margin: 0,
    url: `${appConfig.campaignVoltranUrl}/CampaignBundle`,
    clientUrl: `${appConfig.campaignVoltranUrl}/CampaignBundle`,
    cacheStatus: true,
    paramater: {},
    cacheKey: 'CampaignBundle',
    dataTestId: 'CampaignBundle',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.SPONSORED_BRAND_COMPONENT]: {
    id: 53,
    componentId: 53,
    isFullWidth: false,
    componentTypeName: 'SponsoredBrandComponent',
    margin: 0,
    url: `${appConfig.hepsiAdsSponsoredBrandVoltranUrl}/sponBrands`,
    clientUrl: `${appConfig.hepsiAdsSponsoredBrandVoltranUrl}/sponBrands`,
    cacheStatus: false,
    paramater: {},
    cacheKey: 'SponsoredBrandComponent',
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    isMandatory: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.PREMIUM_BANNER]: {
    id: 52,
    componentId: 52,
    isFullWidth: true,
    componentTypeName: 'PremiumBanner',
    margin: 0,
    url: `${appConfig.loyaltyVoltranUrl}/pdppremiumbanner`,
    clientUrl: `${appConfig.loyaltyVoltranUrl}/pdppremiumbanner`,
    cacheStatus: true,
    paramater: {},
    cacheKey: 'PremiumBanner',
    dataTestId: 'PremiumBanner',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.MORIA_LISTING]: {
    id: 56,
    componentId: 56,
    isFullWidth: false,
    componentTypeName: 'moriaListing',
    margin: 0,
    timeout: 20 * 1000,
    customApiUrl: {
      serverUrl: `${appConfig.moriaApi.serverUrl}/components/QuickFilter`,
      clientUrl: `${appConfig.moriaApi.clientUrl}/components/QuickFilter`,
    },
    cacheStatus: false,
    cacheKey: 'moriaListing',
    dataTestId: 'moriaListing',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,

  },
  [MOBILE_COMPONENTS.VAS]: {
    id: 55,
    componentId: 55,
    isFullWidth: true,
    componentTypeName: 'Vas',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/vas`,
    clientUrl: `${appConfig.cacVoltranUrl}/vas`,
    cacheStatus: true,
    paramater: {},
    cacheKey: 'vas',
    dataTestId: 'vas',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.BUYBACK_ROW]: {
    id: 54,
    componentId: 54,
    isFullWidth: true,
    componentTypeName: 'BuybackRow',
    margin: 0,
    url: 'BuybackRow',
    clientUrl: 'BuybackRow',
    cacheStatus: false,
    cacheKey: 'BuybackRow',
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.BRAND_CONTENT]: {
    id: 60,
    componentId: 60,
    isFullWidth: true,
    componentTypeName: 'BrandRowMobile',
    margin: 0,
    customApiUrl:{
      serverUrl: `${appConfig.brandContentVoltranUrl.serverUrl}/BrandRowMobile`,
      clientUrl: `${appConfig.brandContentVoltranUrl.clientUrl}/BrandRowMobile`,
    },
    cacheStatus: false,
    paramater: {
      //brandId: '4a5de058-0e5f-4450-8bfa-09cc4cb77025',
    },
    cacheKey: 'BrandRowMobile',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.FOLLOW_AND_COLLECT]: {
    id: 61,
    componentId: 61,
    isFullWidth: true,
    componentTypeName: 'FollowAndCollect',
    margin: 0,
    url: `${appConfig.merchantContentVoltranUrl.serverUrl}/Follow`,
    clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/Follow`,
    cacheStatus: false,
    paramater: {},
    cacheKey: 'FollowAndCollect',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.SHIPPING_LOCATION]: {
    id: 63,
    componentId: 63,
    isFullWidth: true,
    componentTypeName: 'ShippingLocation',
    margin: 0,
    url: `${appConfig.shippingVoltranUrl.serverUrl}/shippingLocation`,
    clientUrl: `${appConfig.shippingVoltranUrl.clientUrl}/shippingLocation?newPopoverDisabled`,
    cacheStatus: true,
    cacheKey: 'shipping-location',
    cacheExpireTime: 0,
    paramater: {
      mobile: 'true',
      selectorViewType: 'bottom_sheet'
    }
  },
  [MOBILE_COMPONENTS.BNPL]: {
    id: 62,
    componentId: 62,
    isFullWidth: true,
    componentTypeName: 'Bnpl',
    margin: 0,
    url: `${appConfig.sardesWalletVoltranUrl}/AltPayBNPLInstallment`,
    clientUrl: `${appConfig.sardesWalletVoltranUrl}/AltPayBNPLInstallment`,
    cacheStatus: false,
    paramater: {},
    cacheKey: 'Bnpl',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.ADVERTISEMENT]: {
    id: 35,
    componentId: 35,
    isFullWidth: true,
    componentTypeName: 'Advertisement',
    margin: 0,
    url: 'advertisement',
    clientUrl: 'advertisement',
    cacheStatus: false,
    cacheKey: '',
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.PREMIUM_CONTENT]: {
    id: 21,
    componentId: 21,
    isFullWidth: true,
    componentTypeName: 'OneClickPayment',
    margin: 0,
    url: `${appConfig.premiumVoltranUrl}/OneClickPayment?source=pdp`,
    clientUrl: `${appConfig.premiumVoltranUrl}/OneClickPayment?source=pdp`,
    cacheStatus: false,
    cacheKey: '',
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [MOBILE_COMPONENTS.PRODUCT_SAFETY_INFORMATION]: {
    id: 70,
    componentId: 70,
    isFullWidth: true,
    componentTypeName: 'ProductSafetyInformation',
    margin: 0,
    url: 'ProductSafetyInformation',
    clientUrl: 'ProductSafetyInformation',
    cacheStatus: false,
    cacheKey: 'product-safety-information',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
}

const DESKTOP_COMPONENTS = {
  HEADER: 'header',
  OLD_HEADER: 'old/header',
  DEALOFTHEDAY: 'dealoftheday',
  NAVIGATION_DESKTOP: 'navigationDesktop',
  ADVERTISEMENT: 'advertisement',
  FOOTER: 'footer',
  ADD_TO_CART: 'addtocart',
  MY_LIST: 'myList',
  FAVORITE: 'favoriteshandler',
  MORIA_LISTING: 'moriaListing',
  ADVANTAGE_MORIA_LISTING: 'advantageMoriaListing',
  MORIA_LISTING_SEARCH_PAGE: 'moriaListingSearchPage',
  BRAND_TABULAR: 'BrandTabular',
  BRAND_LAYOUT: 'BrandLayout',
  BRAND_HEADER: 'BrandHeader',
  MERCHANT_TABULAR: 'MerchantTabular',
  MERCHANT_LAYOUT: 'MerchantLayout',
  MERCHANT_PROFILE: 'MerchantProfile',
  MERCHANT_HEADER: 'MerchantHeader',
  SPONSORED_BRAND_COMPONENT: 'SponsoredBrandComponent',
  RECOMMENDATION: 'Recommendation',
  SPONSORED_PRODUCTS: 'SponsoredProducts',
  MERCHANT_COUPONS: 'MerchantCoupons',
  CAMPAIGN_BUNDLE: 'CampaignBundle',
  BUYBACK: 'Buyback',
  PREMIUM_BANNER: 'PremiumBanner',
  USER_CONTENT: 'Yorumlar',
  PRODUCT_DESCRIPTION: 'ProductDescription',
  BEST_REVIEW: 'bestReview',
  QUESTION_AND_ANSWER: 'QuestionAndAnswer',
  INSTALLMENT: 'Installment',
  LOAN: 'Loan',
  FOLLOW_AND_COLLECT: 'Follow',
  ASK_TO_SELLER: 'AskToSeller',
  PRODUCT_SAFETY_INFORMATION: 'ProductSafetyInformation',
}

const DESKTOP_COMPONENTS_OPTIONS = {
  [DESKTOP_COMPONENTS.ADVERTISEMENT]: {
    id: 1,
    componentId: 1,
    isFullWidth: true,
    componentTypeName: 'Advertisement',
    margin: 0,
    url: 'advertisement',
    clientUrl: 'advertisement',
    cacheStatus: false,
    cacheKey: 'advertisement-top-banner',
    paramater: {
      adUnitPath: '/21797185156/Desktop-Masthead/Desktop-Masthead-Anasayfa',
      useBouncingIndicator: 'true',
      placementForEvents: 'masthead'
    },
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.HEADER]: {
    id: 121,
    componentId: 141,
    isFullWidth: true,
    componentTypeName: 'Header',
    margin: 0,
    url: 'header',
    clientUrl: 'header',
    cacheStatus: false,
    cacheExpireTime: 0,
    cacheKey: 'header',
    paramater: {
      displayColorBand: true,
      deliveryTomorrow: true,
    },
    isMandatory: true,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.OLD_HEADER]: {
    id: 112,
    componentId: 11,
    isFullWidth: true,
    componentTypeName: 'OldHeader',
    margin: 0,
    url: 'old/header',
    clientUrl: 'old/header',
    cacheStatus: false,
    cacheKey: 'old/header',
    cacheExpireTime: 0,
    paramater: {
      asyncFragmentsCss: true
    },
    isMandatory: true,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.NAVIGATION_DESKTOP]: {
    id: 113,
    componentId: 12,
    isFullWidth: true,
    componentTypeName: 'Navigation',
    margin: 0,
    url: 'navigationDesktop',
    clientUrl: 'navigationDesktop',
    cacheStatus: true,
    cacheKey: 'navigationDesktop',
    paramater: {},
    isMandatory: true,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.FOOTER]: {
    id: 23,
    componentId: 8,
    isFullWidth: true,
    componentTypeName: 'Footer',
    margin: 0,
    url: 'footer',
    clientUrl: 'footer',
    cacheStatus: true,
    cacheKey: 'footer',
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.ADD_TO_CART]: {
    componentTypeId: 101,
    id: 101,
    isFullWidth: true,
    componentTypeName: 'addtocart',
    margin: '0px',
    customApiUrl: {
      serverUrl: `${appConfig.checkoutUi.serverUrl}/addtocart`,
      clientUrl: `${appConfig.checkoutUi.clientUrl}/addtocart`,
    },
    componentId: 1,
    isMandatory: false,
    cacheStatus: true,
    cacheKey: 'addtocartDesktop',
    cacheExpireTime: 1000 * 60,
    shouldLoadEagerly: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.FAVORITE]: {
    id: 30,
    componentId: 30,
    isFullWidth: false,
    componentTypeName: 'favoriteshandler',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/favoriteshandler`,
    clientUrl: `${appConfig.cacVoltranUrl}/favoriteshandler`,
    cacheStatus: true,
    cacheKey: 'favoriteshandler',
    timeout: 300,
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MORIA_LISTING]: {
    id: 99,
    componentId: 99,
    isFullWidth: false,
    componentTypeName: 'moriaListing',
    margin: 0,
    cacheStatus: false,
    cacheKey: 'moriaListing',
    timeout: 20 * 1000,
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.ADVANTAGE_MORIA_LISTING]: {
    id: 102,
    componentId: 102,
    isFullWidth: false,
    componentTypeName: 'advantageMoriaListing',
    margin: 0,
    cacheStatus: false,
    cacheKey: 'advantageMoriaListing',
    timeout: 12 * 1000,
    paramater: {
      filtreler: 'VariantList.VariantListing.TagList.avantajli€2dfiyatlar:avantajli€2dfiyatlar'
    },
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.BRAND_TABULAR]: {
    id: 100,
    componentId: 100,
    isFullWidth: true,
    componentTypeName: 'BrandTabular',
    timeout: 1000 * 20,
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.brandContentVoltranUrl.serverUrl}/BrandTabular`,
      clientUrl: `${appConfig.brandContentVoltranUrl.clientUrl}/BrandTabular`,
    },
    cacheStatus: false,
    cacheKey: 'BrandTabular',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.BRAND_LAYOUT]: {
    id: 127,
    componentId: 127,
    isFullWidth: true,
    componentTypeName: 'BrandLayout',
    timeout: 1000 * 20,
    margin: 0,
    customApiUrl:{
      serverUrl: `${appConfig.brandContentVoltranUrl.serverUrl}/BrandLayout`,
      clientUrl: `${appConfig.brandContentVoltranUrl.clientUrl}/BrandLayout`,
    },
    cacheStatus: false,
    cacheKey: 'BrandLayout',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.BRAND_HEADER]: {
    id: 128,
    componentId: 128,
    isFullWidth: true,
    componentTypeName: 'BrandHeader',
    timeout: 1000 * 20,
    margin: 0,
    customApiUrl:{
      serverUrl: `${appConfig.brandContentVoltranUrl.serverUrl}/BrandHeader`,
      clientUrl: `${appConfig.brandContentVoltranUrl.clientUrl}/BrandHeader`,
    },
    cacheStatus: false,
    cacheKey: 'BrandHeader',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MERCHANT_TABULAR]: {
    id: 120,
    componentId: 120,
    isFullWidth: true,
    componentTypeName: 'MerchantTabular',
    margin: 0,
    timeout: 1000 * 20,
    customApiUrl: {
      serverUrl: `${appConfig.merchantContentVoltranUrl.serverUrl}/MerchantTabular`,
      clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/MerchantTabular`,
    },
    cacheStatus: false,
    cacheKey: 'MerchantTabular',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MERCHANT_LAYOUT]: {
    id: 124,
    componentId: 124,
    isFullWidth: true,
    componentTypeName: 'MerchantLayout',
    margin: 0,
    timeout: 1000 * 20,
    customApiUrl: {
      serverUrl: `${appConfig.merchantContentVoltranUrl.serverUrl}/MerchantLayout`,
      clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/MerchantLayout`,
    },
    cacheStatus: false,
    cacheKey: 'MerchantLayout',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MERCHANT_PROFILE]: {
    id: 125,
    componentId: 125,
    isFullWidth: true,
    componentTypeName: 'MerchantProfile',
    margin: 0,
    timeout: 1000 * 20,
    customApiUrl: {
      serverUrl: `${appConfig.merchantContentVoltranUrl.serverUrl}/MerchantProfile`,
      clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/MerchantProfile`,
    },
    cacheStatus: false,
    cacheKey: 'MerchantProfile',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MERCHANT_HEADER]: {
    id: 126,
    componentId: 126,
    isFullWidth: true,
    componentTypeName: 'MerchantHeader',
    margin: 0,
    timeout: 1000 * 20,
    customApiUrl: {
      serverUrl: `${appConfig.merchantContentVoltranUrl.serverUrl}/MerchantHeader`,
      clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/MerchantHeader`,
    },
    cacheStatus: false,
    cacheKey: 'MerchantHeader',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.SPONSORED_BRAND_COMPONENT]: {
    id: 122,
    componentId: 122,
    isFullWidth: true,
    componentTypeName: 'SponsoredBrandComponent',
    margin: 0,
    url: `${appConfig.hepsiAdsSponsoredBrandVoltranUrl}/sponBrands`,
    clientUrl: `${appConfig.hepsiAdsSponsoredBrandVoltranUrl}/sponBrands`,
    cacheStatus: false,
    paramater: {},
    cacheKey: 'SponsoredBrandComponent',
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    isMandatory: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.RECOMMENDATION]: {
    isFullWidth: true,
    componentTypeName: 'Recommendation',
    margin: 0,
    url: 'recommendation',
    clientUrl: 'recommendation',
    cacheStatus: true,
    cacheKey: 'Recommendation',
    dataTestId: 'RecommendationVoltran',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.SPONSORED_PRODUCTS]: {
    id: 49,
    componentId: 49,
    isFullWidth: true,
    componentTypeName: 'sponsoredProducts',
    margin: 0,
    url: `${appConfig.hepsiAdsVoltranUrl}/sponProduct`,
    clientUrl: `${appConfig.hepsiAdsVoltranUrl}/sponProduct`,
    cacheStatus: false,
    paramater: {
      scrollableLayout: true
    },
    cacheKey: 'sponsoredProducts',
    dataTestId: 'sponsoredProducts',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.CAMPAIGN_BUNDLE]: {
    id: 123,
    componentId: 123,
    isFullWidth: true,
    componentTypeName: 'CampaignBundle',
    margin: 0,
    url: `${appConfig.campaignVoltranUrl}/CampaignBundle`,
    clientUrl: `${appConfig.campaignVoltranUrl}/CampaignBundle`,
    cacheStatus: true,
    paramater: {},
    cacheKey: 'CampaignBundle',
    dataTestId: 'CampaignBundle',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: true,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.BUYBACK]: {
    id: 110,
    componentId: 110,
    isFullWidth: true,
    componentTypeName: 'buyback',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/TBA?isOpenTbaDirectly=true`,
    clientUrl: `${appConfig.cacVoltranUrl}/TBA?isOpenTbaDirectly=true`,
    cacheStatus: false,
    cacheKey: 'buyback',
    dataTestId: 'buyback',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.PREMIUM_BANNER]: {
    id: 53,
    componentId: 53,
    isFullWidth: true,
    componentTypeName: 'PremiumBanner',
    margin: 0,
    url: `${appConfig.loyaltyVoltranUrl}/pdppremiumbanner`,
    clientUrl: `${appConfig.loyaltyVoltranUrl}/pdppremiumbanner`,
    cacheStatus: true,
    paramater: {
      iconType: 'big'
    },
    cacheKey: 'PremiumBanner',
    dataTestId: 'PremiumBanner',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.USER_CONTENT]: {
    id: 38,
    componentId: 38,
    isFullWidth: false,
    componentTypeName: 'userContentComments',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/Yorumlar`,
      clientUrl: `${appConfig.userContent.clientUrl}/Yorumlar`,
    },
    cacheStatus: false,
    cacheKey: 'Yorumlar',
    paramater: {
      mobileView: false,
      pageSize: 5,
    },
    isMandatory: false,
    timeout: 600,
    clientTimeout: 2000,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: true,
  },
  [DESKTOP_COMPONENTS.PRODUCT_DESCRIPTION]: {
    id: 41,
    componentId: 41,
    isFullWidth: false,
    componentTypeName: 'ProductDescription',
    margin: 0,
    url: 'ProductDescription',
    clientUrl: 'ProductDescription',
    cacheStatus: false,
    cacheKey: 'ProductDescription',
    dataTestId: 'ProductDescription',
    isMandatory: false,
    paramater: {
      desktop: ''
    },
    timeout: 300,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.BEST_REVIEW]: {
    id: 39,
    componentId: 39,
    isFullWidth: false,
    componentTypeName: 'bestReview',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/bestReview`,
      clientUrl: `${appConfig.userContent.clientUrl}/bestReview`,
    },
    cacheStatus: false,
    cacheKey: 'bestReview',
    timeout: 300,
    paramater: {},
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.QUESTION_AND_ANSWER]: {
    id: 43,
    componentId: 43,
    isFullWidth: true,
    componentTypeName: 'QuestionAndAnswer',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.userContent.serverUrl}/qna`,
      clientUrl: `${appConfig.userContent.clientUrl}/qna`,
    },
    cacheStatus: false,
    cacheKey: 'QuestionAndAnswer',
    dataTestId: 'QuestionAndAnswerVoltran',
    timeout: 600,
    clientTimeout: 2000,
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.INSTALLMENT]: {
    id: 44,
    componentId: 44,
    isFullWidth: true,
    componentTypeName: 'installment',
    margin: 0,
    url: `${appConfig.sardesInstallmentVoltranUrl}/Installment`,
    clientUrl: `${appConfig.sardesInstallmentVoltranUrl}/Installment`,
    cacheStatus: true,
    cacheKey: 'installment',
    dataTestId: 'installment',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.LOAN]: {
    id: 45,
    componentId: 45,
    isFullWidth: true,
    componentTypeName: 'loan',
    margin: 0,
    url: `${appConfig.sardesInstallmentVoltranUrl}/loan`,
    clientUrl: `${appConfig.sardesInstallmentVoltranUrl}/loan`,
    cacheStatus: false,
    cacheKey: 'loan',
    dataTestId: 'loan',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.FOLLOW_AND_COLLECT]: {
    id: 61,
    componentId: 61,
    isFullWidth: true,
    componentTypeName: 'FollowAndCollect',
    margin: 0,
    url: `${appConfig.merchantContentVoltranUrl.serverUrl}/Follow`,
    clientUrl: `${appConfig.merchantContentVoltranUrl.clientUrl}/Follow`,
    cacheStatus: false,
    paramater: {},
    cacheKey: 'FollowAndCollect',
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.ASK_TO_SELLER]: {
    id: 46,
    componentId: 46,
    isFullWidth: true,
    componentTypeName: 'AskToSeller',
    margin: 0,
    url: `${appConfig.askToSellerVoltranUrl}/asktoseller/wc`,
    clientUrl: `${appConfig.askToSellerVoltranUrl}/asktoseller/wc`,
    cacheStatus: true,
    cacheKey: 'AskToSeller',
    dataTestId: 'AskToSellerVoltran',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.MY_LIST]: {
    id: 47,
    componentId: 47,
    isFullWidth: true,
    componentTypeName: 'myList',
    margin: 0,
    url: `${appConfig.cacVoltranUrl}/MyLists`,
    clientUrl: `${appConfig.cacVoltranUrl}/MyLists`,
    cacheStatus: true,
    cacheKey: 'myList',
    dataTestId: 'myList',
    isMandatory: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
  [DESKTOP_COMPONENTS.PRODUCT_SAFETY_INFORMATION]: {
    id: 70,
    componentId: 70,
    isFullWidth: true,
    componentTypeName: 'ProductSafetyInformation',
    margin: 0,
    url: 'ProductSafetyInformation',
    clientUrl: 'ProductSafetyInformation',
    cacheStatus: false,
    cacheKey: 'product-safety-information',
    isMandatory: false,
    imagesLoadEagerly: false,
    scriptsLoadEagerly: true,
    onlyClientSide: false,
    passCookies: false,
  },
}

const COMMON_COMPONENTS = {
  HYDRA_RENDERING_PAGE: 'HydraRenderingPage'
}

const COMMON_COMPONENTS_OPTIONS = {
  [COMMON_COMPONENTS.HYDRA_RENDERING_PAGE]: {
    id: 62,
    componentId: 62,
    isFullWidth: true,
    componentTypeName: 'HydraRenderingPage',
    margin: 0,
    customApiUrl: {
      serverUrl: `${appConfig.hydraVoltran.serverUrl}/RenderingPage`,
      clientUrl: `${appConfig.hydraVoltran.clientUrl}/RenderingPage`,
    },
    cacheStatus: false,
    paramater: {},
    cacheKey: 'HydraRenderingPage',
    timeout: 1000 * 5,
    isMandatory: false,
    scriptsLoadEagerly: false,
    onlyClientSide: false,
    passCookies: false,
  }
}

const VOLTRAN_EVENT_BUS = {
  ADVERTISEMENT: 'storefront.voltran.advertisement',
  LOCATION_CHANGE: 'shipping.voltran.shippingLocation.location.change'
}

export {
  DEVICE_TYPE,
  MOBILE_COMPONENTS,
  MOBILE_COMPONENTS_OPTIONS,
  DESKTOP_COMPONENTS,
  DESKTOP_COMPONENTS_OPTIONS,
  VOLTRAN_EVENT_BUS,
  COMMON_COMPONENTS,
  COMMON_COMPONENTS_OPTIONS,
}
